/*
    Static funds for local testing
    It originally comes from the WP
*/
export const a_funds = {
  premium: [
    {
      id: 3212,
      name: "VIG Prémium Everest Alapokba Fektető Részalap A sorozat",
      customName: "Prémium Everest A",
      sorozat: "A",
    },
    {
      id: 0,
      name: "VIG Európai Részvény Alapokba Fektető Részalap A sorozat",
      customName: "Európai Részvény A",
      sorozat: "A",
    },
    {
      id: 0,
      name: "VIG Európai Részvény Alapokba Fektető Részalap E sorozat",
      customName: "Európai Részvény E",
      sorozat: "E",
    },
    {
      id: 0,
      name: "VIG Amerikai Részvény Alapokba Fektető Részalap A sorozat",
      customName: "Amerikai Részvény A",
      sorozat: "A",
    },
    {
      id: 0,
      name: "VIG Amerikai Részvény Alapokba Fektető Részalap U sorozat",
      customName: "Amerikai Részvény U",
      sorozat: "U",
    },
    {
      id: 0,
      name: "VIG Arany Alapokba Fektető Részalap A sorozat",
      customName: "Arany A",
      sorozat: "A",
    },
    {
      id: 0,
      name: "VIG Arany Alapokba Fektető Részalap E sorozat",
      customName: "Arany E",
      sorozat: "E",
    },
    {
      id: 0,
      name: "VIG Arany Alapokba Fektető Részalap U sorozat",
      customName: "Arany U",
      sorozat: "U",
    },
    /*       {
          "id": 5716,
          "name": "Prémium Dynamic"
      },
      {
          "id": 5717,
          "name": "Prémium Everest"
      },
      {
          "id": 5718,
          "name": "Prémium Expert"
      } */
  ],
  deviza: [
    {
      EUR: [
        {
          id: 5691,
          name: "VIG Alfa E sorozat",
        },
        {
          id: 2644,
          name: "VIG Feltörekvő ESG B sorozat",
        },
        {
          id: 2668,
          name: "VIG Feltörekvő Európa Kötvény A sorozat",
        },
        {
          id: 2645,
          name: "VIG Közép-Eu-i Részv. B sorozat",
        },
        {
          id: 5498,
          name: "VIG Maraton E sorozat",
        },
        {
          id: 2455,
          name: "VIG Megatrend A sorozat",
        },
        {
          id: 5696,
          name: "VIG MoneyMaxx E sorozat",
        },
        {
          id: 2646,
          name: "VIG Opportunity Részvény B sorozat",
        },
        {
          id: 5261,
          name: "VIG Panoráma E sorozat",
        },
      ],

      USD: [
        {
          id: 5693,
          name: "VIG Alfa U sorozat",
        },
        {
          id: 7004,
          name: "VIG Feltörekvő ESG U sorozat",
        },
        {
          id: 7084,
          name: "VIG Feltörekvő Európa Kötvény U sorozat",
        },
        {
          id: 5502,
          name: "VIG Maraton U sorozat",
        },
        {
          id: 7050,
          name: "VIG Megatrend U sorozat",
        },
        {
          id: 5698,
          name: "VIG MoneyMaxx U sorozat",
        },
        {
          id: 5265,
          name: "VIG Panoráma U sorozat",
        },
      ],
    },
  ],
  huf: [
    {
      id: 2030,
      name: "VIG Alfa A sorozat",
    },
    {
      id: 4038,
      name: "VIG BondMaxx A sorozat",
    },
    {
      id: 1341,
      name: "VIG Fejlett Piaci Államkötvény A sorozat",
    },
    {
      id: 2385,
      name: "VIG Feltörekvő ESG A sorozat",
    },
    {
      id: 7083,
      name: "VIG Feltörekvő Európa Kötvény B sorozat",
    },
    {
      id: 1343,
      name: "VIG Közép-Eu-i Részv. A sorozat",
    },
    {
      id: 2389,
      name: "VIG Lengyel Kötvény Alap A sorozat",
    },
    {
      id: 4259,
      name: "VIG Lengyel Részvény B sorozat",
    },
    {
      id: 1342,
      name: "VIG Magyar Kötvény A sorozat",
    },
    {
      id: 1198,
      name: "VIG Magyar Pénzpiaci A sorozat",
    },
    {
      id: 5497,
      name: "VIG Maraton A sorozat",
    },
    {
      id: 3209,
      name: "VIG Megatrend B sorozat",
    },
    {
      id: 1641,
      name: "VIG MoneyMaxx A sorozat",
    },
    {
      id: 1339,
      name: "VIG Opportunity Részvény A sorozat",
    },
    {
      id: 2323,
      name: "VIG Ózon Alap A sorozat",
    },
    {
      id: 5260,
      name: "VIG Panoráma A sorozat",
    },
    {
      id: 8730,
      name: "VIG Russia Részvény Alap AIL sorozat",
    },
    {
      id: 3528,
      name: "VIG Smart Money bef. jegy. undefined sorozat",
    },
    {
      id: 5243,
      name: "VIG Tempó Allegro 10 undefined sorozat",
    },
    {
      id: 5235,
      name: "VIG Tempó Andante 2 undefined sorozat",
    },
    {
      id: 5239,
      name: "VIG Tempó Moderato 6 undefined sorozat",
    },
    {
      id: 7748,
      name: "VIG Magyar Indexkövető Részvény Részalap B sorozat",
    },
  ],
};
